export const BNB_ADMIN_LIST = ["Godfather", "Gangi", "Vocedelpadrino"];
export const PULSE_ADMIN_LIST = [
  "Godfather",
  "Creya",
  "kkkk",
  "Vocedelpadrino",
];
